<template>
  <div class="quickform">
    <div class="quickform__tabs">
      <ul>
        <li
          @click="currentTab = tab"
          class="tab"
          v-for="tab in tabs"
          :key="tab.code"
          :class="{ active: currentTab?.code === tab.code }"
        >
          <a v-if="tab.component">
            {{ tab.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="quickform__content">
      <KeepAlive>
        <component
          :is="currentTab?.component"
          class="tab"
          :tab="currentTab"
        ></component>
      </KeepAlive>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { QuickformTab } from "@/modules/Quickform/models/QuickformTab";
import { shallowRef } from "vue";

interface Props {
  tabs: QuickformTab[];
  activeTabIndex?: number;
}

const props = defineProps<Props>();
const currentTab = shallowRef(props.tabs[props.activeTabIndex ?? 0]);
</script>

<style lang="scss" scoped>
.quickform {
  border: 1px solid rgb(199, 199, 199);
  margin: 0 auto;
  width: 100%;
  max-width: 1260px;
  border-radius: 5px;
  background-color: white;
  
  &__tabs {
    padding: 5px 25px;
    padding-top: 20px;
    ul {
      display: flex;
      padding: 0;
      gap: 30px;

      @include tablet {
        justify-content: center;
      }

      .tab {
        display: flex;
        justify-content: flex-start;
        position: relative;
        cursor: pointer;
        height: 35px;
        overflow: hidden;

        @include tablet {
          justify-content: center;
        }

        &:hover {
          a {
            color: var(--c-pink);
          }
        }

        a {
          color: var(--c-black);
          position: relative;
          text-transform: uppercase;
          font-weight: 700;
          font-size: 0.875rem;
          line-height: 1;
          letter-spacing: 0.04em;
          overflow: hidden;
        }
      }
      .active {
        a {
          color: var(--c-pink);
          &::after {
            position: absolute;
            content: "";
            display: block;
            margin-top: 5px;
            height: 2px;
            background-color: #c22b74;
            width: 100%;
          }
        }
      }
    }
  }

  &__content {
    padding: 20px 25px;
  }
}
</style>
